export default [
  {
    path: '/',
    name: 'index',
    redirect: { name: 'home' },
    meta: {
      layout: 'base'
    }
  }, 
  {
    path: '/support',
    name: 'support',
    component: () => import('@/views/Support'),
    meta: {
      requiresAuth: true,
      title:'Support',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Support' }
      ]
    }
  }, 
  {
    path: '/update',
    name: 'update',
    component: () => import('@/views/Update'),
    meta: {
      layout: 'base'
    }
  }, 
  
  {
    path: '*',
    name: '404',
    component: () => import('@/views/Error'),
    meta: {
      layout: 'base'
    }
  }
]